<template>
    <Transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="translate-y-1 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="translate-y-0 opacity-100"
        leave-to-class="translate-y-1 opacity-0"
    >
        <div
            v-if="showPopup"
            class="fixed bottom-4 right-4 z-50 max-w-md bg-surface rounded-popover shadow-lg border border-border p-6 bg-white"
        >
            <h4 class="mb-2">
                {{ $lang.get('Cookie & tracking consent') }}
            </h4>

            <p class="text-sm text-text-light mb-4">
                {{
                    $lang.get(
                        'We use cookies to track your interactions with our site and analyze site usage to improve our services. Would you like to accept analytical cookies and allow interaction tracking?'
                    )
                }}
            </p>

            <div class="flex justify-end gap-3">
                <SecondaryButton
                    @click="decline"
                    class="px-4 py-2 text-sm font-medium text-text-light hover:text-text transition-colors"
                >
                    {{ $lang.get('Decline') }}
                </SecondaryButton>

                <PrimaryButton
                    @click="accept"
                    class="px-4 py-2 text-sm font-medium bg-primary text-white rounded hover:bg-primary-dark transition-colors"
                >
                    {{ $lang.get('Accept') }}
                </PrimaryButton>
            </div>
        </div>
    </Transition>
</template>

<script>
import PrimaryButton from '@/Components/Elements/PrimaryButton.vue'
import SecondaryButton from '@/Components/Elements/SecondaryButton.vue'

export default {
    name: 'MatomoConsentPopup',

    components: {
        PrimaryButton,
        SecondaryButton,
    },

    data() {
        return {
            showPopup: false,
        }
    },

    mounted() {
        this.checkMatomoIsInitialized()
        this.$bus.on('matomoClearConsentChoice', this.clearConsentChoice)
    },

    unmounted() {
        this.$bus.off('matomoClearConsentChoice', this.clearConsentChoice)
    },

    methods: {
        /**
         * As this component might have been mounted before the matomo script is loaded, we need to wait for it to be available
         * Try 5 times with 100ms intervals
         */
        checkMatomoIsInitialized() {
            let fetchMatomo = (counter = 0) => {
                if (this.$matomo) {
                    this.checkConsent()
                } else if (counter < 5) {
                    setTimeout(() => {
                        fetchMatomo(counter + 1)
                    }, 100)
                }
            }
            fetchMatomo()
        },

        /**
         * Will check if the user has made a choice, either accepted or declined the consent
         * of tracking and storing cookies
         * If not they will be shown the consent popup where they can make a choice
         */
        checkConsent() {
            const hasDeclinedConsent = localStorage.getItem(
                'mtm_declined_tracking'
            )
            if (!this.$matomo.hasRememberedConsent() && !hasDeclinedConsent) {
                this.showPopup = true
            }
        },

        /**
         * Using matomo we accept the consent for the user which will then be stored using cookies
         */
        accept() {
            this.$matomo.rememberConsentGiven()
            this.$matomo.rememberCookieConsentGiven()
            this.showPopup = false
            // Remove the local storage value if the user has declined consent previously
            localStorage.removeItem('mtm_declined_tracking')
        },

        /**
         * Using matomo we decline the consent for the user which will then be stored using cookies
         */
        decline() {
            this.showPopup = false
            // Set a local storage value to remember the user has declined consent
            localStorage.setItem('mtm_declined_tracking', true)
        },

        /**
         * Removes and choice the user made for tracking so that the choise can be made again
         * This is used when the user updates their tracking preferences
         */
        clearConsentChoice() {
            // Forget matomo consent if previously given
            this.$matomo.forgetConsentGiven()
            // Remove the local storage value if the user has declined consent previously
            localStorage.removeItem('mtm_declined_tracking')

            this.checkConsent()
        },
    },
}
</script>
